<div class="layout-topbar top-bar-custom">
  <div class="topbar-left">
    <img id="logo-mobile" class="logo-desktop" src="../../../../assets/images/header-white-logo.png" alt="PaperTrl"/>
  </div>
</div>
<div class="exception-body mobile-fields" >
  <div class="exception-content">
    <div class="exception-detail">
      <div class="grid">
        <p-card class="card-custom" styleClass="p-card-shadow-remove card-custom">
          <div class="card-custom-padding">
            <h5 class="card-header-custom">{{ headerMessage }}</h5>
            <img class="body-img" src="../../../../assets/images/email-sent.png" alt="Email sent" width="200">
            <p class="card-subheader-custom">{{message}}</p>
          </div>
        </p-card>
      </div>
    </div>
  </div>
</div>


